// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"_cf4d28ac","videoContainer":"_62d46cdb","loading":"_d579980b","loadingText":"_50231536"};